import { SelectProps } from "@material-ui/core"
import { Dispatch } from "redux"
import { IExtraServicesItem, IExtraServicesPriceAmount } from "./extraServices"
import { ProductBasket } from "../../Modules/Basket/basketTypes"
import { IOrderLine } from "../appTypes"
import { DateTime } from "luxon"

export enum DeliveryType {
    CANTEEN = 'canteen',
    PICK_UP = 'pick-up',
    DELIVERY = 'delivery'
}

export enum DeliveryPayloadType {
    CANTEEN = 'CANTEEN',
    DELIVERY = 'DELIVERY',
    PICK_UP = 'PICK_UP'
}

export enum DeliveryPayloadLocationType {
    RESOURCE = 'RESOURCE',
    OTHER_LOCATION = 'OTHER_LOCATION',
}

export interface IDeliveryFormExtraServiceItem {
    id: number
    name: string
    currency: string
    amount: number
    basePrice: number
    mininumPrice: IExtraServicesPriceAmount
    maximumPrice: IExtraServicesPriceAmount
}

export interface IBasketDeliveryPaymentFormValues {
    billReceiver: IFormikSelectOptionsProps[]
    costCenters: IFormikSelectOptionsProps[]
}

export interface IBasketExtraServicesFormValues {
    extraServices: IDeliveryFormExtraServiceItem[]
}

export interface IBasketDeliveryFormValues {
    deliveryDate: string
    deliveryTime: string
    meetingName: string
    seats: number
    deliveryType: string
    deliveryLocation: string
    hasOtherDeliveryLocation: boolean
    otherDeliveryLocation: string
    otherMessage: string
    isConfirmed: boolean
    deadlineMessage: string
    deadlineMerchantMessage: string
}

export interface IBasketMeetingPlanningFormField extends IBasketDeliveryFormValues, IBasketExtraServicesFormValues, IBasketDeliveryPaymentFormValues {}

export interface IInitialDeliveryFormValues {
    meetingName: string
    fromDate: string
    toDate: string
    deliveryType: string
    deliveryLocation: string
    hasOtherDeliveryLocation: boolean
    otherDeliveryLocation: string
    seats: number
}

export interface IDeliveryFormValues {
    isCompleted: boolean
    deliveryTime: string
    extraServices: IDeliveryFormExtraServiceItem[]
    price: number
}

export interface IDeliveryForm extends IInitialDeliveryFormValues, IDeliveryFormValues {}

export interface IFormikSelectOptionsProps {
    id?: number;
    label: string;
    value: string | number
}

export interface IFormikSelectProps extends SelectProps {
    name: string
    label: string
    options: IFormikSelectOptionsProps[]
    placeholder?: string
    isFloatingLabel?: boolean
    required?: boolean
}

export interface IDeliveryFormWrapperProps {
    deliveryId: string | null
    isInitialShow: boolean
    initialDeliveryForm: IInitialDeliveryFormValues | null
    meetingPlaningDeliveries: IDelivery[]
    userCanteenId: number | undefined
    dispatch: Dispatch
}

export interface IDeliveryFormProps {
    isInitialShow: boolean
    initialDeliveryForm: IInitialDeliveryFormValues | null
    currentMeetingPlaningDelivery: IDelivery | null
    userCanteenId: number | undefined
    onSubmit: (formValues: IDeliveryForm) => void
}

export interface IDisabledDatePickerProps {
    label: string
    selectedValue: string
}

export interface IControlComponentProps {
    name: string
    label?: string
    placeholder?: string
    isFloatingLabel?: boolean
    required?: boolean
    disabled?: boolean
}

export interface IExtraServiceAccordionProps {
    name: string
    service: IExtraServicesItem,
    seats: number
    selectedServices: IDeliveryFormExtraServiceItem[]
    setSelectedServices: (services: IDeliveryFormExtraServiceItem[]) => void
}

export interface IDeliveryTypeFormSectionProps {
    userCanteenId: number | undefined
    isInitialShow: boolean
}

export interface ISeatsQuantityControlsProps {
    quantity: number;
    className?: string;
    onComplete?: (amount: number) => void;
}

export interface IDeliveryPayload {
    id: string
    isInitial: boolean
    order: ProductBasket
    formFields: IDeliveryForm
}

export interface IDelivery {
    id: string
    isInitial: boolean
    order: ProductBasket
    formFields: IDeliveryFormValues
}

export interface IDeliveryOrderPayload {
    deliveryId: string
    order: ProductBasket
}

export enum IMeetingPlanningOrderModalAction {
    Accept = 'accept',
    Edit = 'edit',
    Denied = 'denied',
    Close = 'close'
}

export interface IMeetingPlanningOrderConfirmationModal {
    isOpen: boolean
    userId: number | null
    formData: IBasketDeliveryFormValues | null
}

export interface IMeetingPlanningOrderCompleteModal {
    isOpen: boolean
    isEdit: boolean
    isResourceBookingOrder: boolean
    deliveryDate: string
    deliveryTime: string
}

export type IBasketMeetingPlanningFormFieldOptional = Partial<IBasketMeetingPlanningFormField>;

export interface IEditMeetingOrderData {
    orderId?: number
    orderData?: IBasketMeetingPlanningFormFieldOptional
    products?: Array<{ id: number, date: DateTime }>
    isEditOrder?: boolean
    isResourceBookingOrder?: boolean
}
